/* eslint-disable */
/**
 * Thin compatibility wrapper.
 *
 * The original monolithic `api.ts` has been refactored and split into
 * dedicated service classes under `./api/` for better maintainability.
 *
 * This file now merely re-exports the new modular implementation so that
 * existing imports like:
 *   import apiService from '@/services/api';
 * continue to work without modification.
 */

// Re-export everything from the new aggregated API module
export * from './api/index';

// Import and re-export the default export from the api module
import apiServiceInstance from './api/index';
export { apiServiceInstance as apiService };
export default apiServiceInstance;
